export default "__VITE_ASSET__f5679bf8__"